<template>
    <v-layout align-start>
        <v-flex>
            <v-data-table :headers="headers" :search="search" :items="clients" :loading="loadingtable" sort-by="name"
                class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Clientes</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field class="text-xs-center" v-model="search" append-icon="search" label="Búsqueda"
                            single-line hide-details></v-text-field>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" persistent max-width="600px">
                            <template v-slot:activator="{ on }">
                                <v-btn color="green" dark v-on="on">
                                    <v-icon left dark>person_add</v-icon>Agregar
                                </v-btn>
                            </template>
                            <v-form ref="form">
                                <v-card>
                                    <v-card-title>
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field label="Código*" :rules="[rules.required]"
                                                        v-model="clientModel.id"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field label="Nombre*" :rules="[rules.required]"
                                                        v-model="clientModel.name"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="6" md="6">
                                                    <v-text-field label="Celular*" :rules="[rules.required]"
                                                        v-mask="mask" v-model="clientModel.phone"></v-text-field>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                        <small>*Campo requerido.</small>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="dialog = false">Cerrar</v-btn>
                                        <v-btn color="green" dark text @click="save">
                                            <v-icon left>save</v-icon>Guardar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-form>
                        </v-dialog>
                        <v-dialog v-model="uploadModal" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn :loading="loadingUploadBtn" :disabled="disableUploadBtn" color="orange" dark
                                    v-on="on" class="mx-3">
                                    <v-icon left dark>mdi-cloud-upload</v-icon>Importar
                                </v-btn>
                            </template>
                            <v-card>
                                <v-card-title>
                                    <span class="headline">Importar Clientes</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-container>
                                        <v-row>
                                            <v-file-input v-model="file" label="Cargar plantilla .csv o .xlsx" accept=".csv,.xlsx,.xls"></v-file-input>
                                            <v-tooltip top>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn class="ma-2" v-bind="attrs" v-on="on" href="template.xlsx"
                                                        dark download>
                                                        <v-icon dark> mdi-cloud-download </v-icon>
                                                    </v-btn>
                                                </template>
                                                <span>Descargar Plantilla Excel</span>
                                            </v-tooltip>
                                            <v-spacer></v-spacer>
                                        </v-row>
                                        <v-row>
                                            <v-btn @click="UploadClientsTemplate()" color="orange" dark>
                                                <v-icon left>mdi-cloud-upload</v-icon>Importar
                                            </v-btn>
                                            <v-btn class="mx-3" @click="hideUploadModal()" color="blue darken-1"
                                                text>Cancelar</v-btn>
                                        </v-row>
                                    </v-container>
                                </v-card-text>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template #[`item.actions`]="{ item }">
                    <v-icon size="sm" variant="outline-info" color="blue" class="mr-1"
                        @click="editItem(item)">edit</v-icon>
                    <v-icon size="sm" color="red" class="mr-1" @click="deleteItem(item)">delete</v-icon>
                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="getClients">
                        <v-icon left dark>autorenew</v-icon>Refrescar
                    </v-btn>
                </template>
            </v-data-table>
        </v-flex>
    </v-layout>
</template>

<script>
import {
    getAuth
} from "firebase/auth";
import {
    firebaseApp
} from "../../firebase";
import {
    getFirestore,
    doc,
    updateDoc,
    getDocsFromCache,
    getDocs,
    setDoc,
    deleteDoc,
    collection,
} from "firebase/firestore";
import ClientModel from "../../models/ClientModel";
import {
    mask
} from "vue-the-mask";
import * as XLSX from 'xlsx';

const {
    phoneNumberFormatter
} = require("../../helpers/formatter");

const auth = getAuth();
const db = getFirestore(firebaseApp);
const branchesRef = collection(db, "branches");

export default {
    directives: {
        mask,
    },
    data: () => ({
        clients: [],
        mask: "##########",
        dialog: false,
        headers: [{
            text: "Id",
            sortable: true,
            value: "id",
        },
        {
            text: "Nombre",
            sortable: true,
            value: "name",
        },
        {
            text: "Apellido",
            sortable: true,
            value: "lastName",
        },
        {
            text: "Celular",
            sortable: false,
            value: "phone",
        },
        {
            text: "Email",
            sortable: false,
            value: "email",
        },
        {
            text: "Msg Exitosos",
            sortable: true,
            value: "successfulCount",
        },
        {
            text: "Msg Fallidos",
            sortable: true,
            value: "failCount",
        },
        {
            text: "Opciones",
            value: "actions",
            sortable: false,
        },
        ],
        rules: {
            required: (value) => !!value || "Requerido.",
        },
        search: "",
        editedIndex: -1,
        clientModel: new ClientModel(),
        fileProcessed: null,
        file: null,
        uploadModal: false,
        loadingUploadBtn: false,
        disableUploadBtn: false,
        loadingtable: false,
        currentBranch: null,
        customersList: []
    }),
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nuevo Cliente" : "Actualizar Cliente";
        },

        selectedBranch() {
            return this.$store.state.selectedBranch;
        }
    },
    watch: {
        dialog(val) {
            val || this.close();
            if (this.$refs.form !== undefined) this.$refs.form.resetValidation();
        },
        selectedBranch(newValue) {
            this.currentBranch = newValue;
            this.getClients();
        }
    },
    mounted() { },
    created() {
        this.currentBranch = this.$store.state.selectedBranch;
        this.getClients();
    },
    methods: {
        displayNotification(type, message) {
            this.$swal.fire({
                position: "top-end",
                type: type,
                title: message,
                showConfirmButton: false,
                timer: 1500,
            });
        },

        async UploadClientsTemplate() {
            if (this.file == null) {
                this.displayNotification(
                    "error",
                    "El archivo es de un formato incorrecto o no se ha cargado."
                );
                return;
            }

            this.loadingUploadBtn = true;
            this.uploadModal = false;

            this.customersList = [];

            await this.processFile();

            console.log("" + this.customersList.length + " registros procesados");

            this.customersList.forEach((a) => {
                let existingClient = this.clients.find(client => client.id === a.id);
                let phone = (a.phone !== undefined && a.phone !== "") ? phoneNumberFormatter(a.phone) : "";
                let email = (a.email !== undefined && a.email !== "") ? a.email : "";
                let lastName = (a.lastName !== undefined && a.lastName !== "") ? a.lastName : "";
                let name = (a.name !== undefined && a.name !== "") ? a.name : "";
                if (existingClient) {
                    if (existingClient.name !== a.name || existingClient.phone !== phone
                        || existingClient.lastName !== a.lastName || existingClient.email !== a.email) {
                        updateDoc(doc(branchesRef, this.currentBranch, "clients", a.id), {
                            id: a.id,
                            name: name || "",
                            phone: phone || "",
                            lastName: lastName || "",
                            email: email || "",
                        })
                            .then(() => { })
                            .catch((error) => {
                                console.log(error.message);
                                this.loadingUploadBtn = false;
                            });
                    }
                }
                else {
                    setDoc(doc(branchesRef, this.currentBranch, "clients", a.id), {
                        id: a.id,
                        name: name || "",
                        phone: phone || "",
                        lastName: lastName || "",
                        email: email || "",
                    })
                        .then(() => { })
                        .catch((error) => {
                            console.log(error.message);
                            this.loadingUploadBtn = false;
                        });
                }
            });

            this.loadingUploadBtn = false;
            this.file = null;

            this.displayNotification(
                "success",
                "Se cargaron los registros correctamente."
            );
            this.getClients();
        },

        async processFile() {
            try {
                await this.loadXlsData()
            } catch (error) {
                console.error("Error parsing file:", error.message);
            }
        },

        async loadXlsData() {
            const readFile = (file) => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        const data = new Uint8Array(e.target.result);
                        const workbook = XLSX.read(data, { type: 'array' });
                        const sheetName = workbook.SheetNames[0];
                        const sheet = workbook.Sheets[sheetName];
                        // Use defval to ensure empty cells return empty string
                        const jsonData = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
                        resolve(jsonData);
                    };
                    reader.onerror = (error) => reject(error);
                    reader.readAsArrayBuffer(this.file);
                });
            };

            try {
                const jsonData = await readFile(this.file);

                if (jsonData.length === 0) {
                    console.error('El archivo está vacío');
                    this.displayNotification("error", "El archivo está vacío");
                    return;
                }

                // Normalize header: handles camelCase, PascalCase, snake_case, UPPERCASE, etc.
                const normalizeHeader = (header) => {
                    return String(header)
                        .trim()
                        // Remove accents/diacritics
                        .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
                        // Convert camelCase/PascalCase to lowercase with spaces
                        .replace(/([a-z])([A-Z])/g, '$1 $2')
                        // Replace underscores and hyphens with spaces
                        .replace(/[_-]/g, ' ')
                        // Convert to lowercase
                        .toLowerCase()
                        // Remove extra spaces
                        .replace(/\s+/g, ' ')
                        .trim();
                };

                // Get headers from first row and normalize them
                const headers = jsonData[0].map(h => normalizeHeader(h));

                console.log('Encabezados detectados:', headers);

                // Function to find column index by possible header names
                const getColumnIndex = (possibleNames) => {
                    for (let name of possibleNames) {
                        const normalizedName = normalizeHeader(name);
                        // Try exact match first
                        let index = headers.findIndex(h => h === normalizedName);
                        if (index !== -1) return index;

                        // Then try if header includes the search term (but not vice versa to avoid false positives)
                        index = headers.findIndex(h => h.includes(normalizedName) && h.length > normalizedName.length);
                        if (index !== -1) return index;
                    }
                    return -1;
                };

                // Find column indices dynamically based on header names
                // Supports: Codigo, CODIGO, codigo, Código, tel_celular, TelCelular, telCelular, etc.
                const idIndex = getColumnIndex(['codigo', 'code', 'id']);
                const nameIndex = getColumnIndex(['nombre', 'name', 'nombres']);
                const lastNameIndex = getColumnIndex(['apellido', 'lastname', 'last name', 'surname', 'apellidos']);
                const phoneIndex = getColumnIndex(['celular', 'telefono', 'tel', 'phone', 'movil', 'telcelular', 'tel celular']);
                const emailIndex = getColumnIndex(['email', 'correo', 'mail', 'e mail']);

                console.log('Índices de columnas:', {
                    codigo: idIndex,
                    nombre: nameIndex,
                    apellido: lastNameIndex,
                    telefono: phoneIndex,
                    email: emailIndex
                });

                // Map data rows (skip header row)
                this.customersList = jsonData.slice(1).map((row) => {
                    return {
                        id: idIndex !== -1 ? String(row[idIndex] || "").trim() : "",
                        name: nameIndex !== -1 ? String(row[nameIndex] || "").trim() : "",
                        lastName: lastNameIndex !== -1 ? String(row[lastNameIndex] || "").trim() : "",
                        phone: phoneIndex !== -1 ? String(row[phoneIndex] || "").trim() : "",
                        email: emailIndex !== -1 ? String(row[emailIndex] || "").trim() : "",
                    };
                });

                // Filter out invalid entries (must have at least id, name and phone)
                this.customersList = this.customersList.filter(
                    (x) =>
                        x.id !== undefined &&
                        x.id !== "" &&
                        x.name !== undefined &&
                        x.name !== "" &&
                        x.phone !== undefined &&
                        x.phone !== ""
                );

                console.log('Registros válidos encontrados:', this.customersList.length);
            } catch (error) {
                console.error('Error reading file:', error);
                this.displayNotification("error", "Error al procesar el archivo: " + error.message);
            }
        },

        async getClients() {
            this.loadingtable = true;
            this.clients = [];
            let querySnapshot = await getDocs(
                collection(db, "branches/" + this.currentBranch + "/clients")
            );

            querySnapshot.forEach((doc) => {
                this.clients.push({
                    id: doc.data().id,
                    name: doc.data().name,
                    phone: doc.data().phone,
                    lastName: doc.data().lastName,
                    email: doc.data().email,
                    successfulCount: doc.data().successfulCount,
                    failCount: doc.data().failCount,
                });
            });
            this.loadingtable = false;
        },

        editItem(item) {
            this.editedIndex = this.clients.indexOf(item);
            this.clientModel = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            this.$swal
                .fire({
                    title: "¿Está Seguro de Eliminar este registro?",
                    text: "¡No será posible revertir el cambio!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#d33",
                    confirmButtonText: "¡Borrar!",
                    cancelButtonText: "Cancelar",
                })
                .then((result) => {
                    if (result.value) {
                        deleteDoc(
                            doc(branchesRef, this.currentBranch, "clients", item.id)
                        )
                            .then(() => {
                                this.close();
                                this.getClients();
                                this.clean();
                                this.displayNotification(
                                    "success",
                                    "Se eliminó el registro correctamente."
                                );
                            })
                            .catch(function (error) {
                                this.displayNotification("error", error.message);
                            });
                    }
                });
        },

        async save() {
            console.log(this.clientModel);
            if (this.$refs.form.validate()) {
                setDoc(doc(branchesRef, this.currentBranch, "clients", this.clientModel.id), {
                    id: this.clientModel.id,
                    name: this.clientModel.name,
                    phone: phoneNumberFormatter(this.clientModel.phone),
                })
                    .then(() => {
                        this.close();
                        this.getClients();
                        this.clean();
                        this.displayNotification(
                            "success",
                            "Se realizó la operación correctamente."
                        );
                    })
                    .catch((error) => {
                        console.log(error.message);
                        this.loadingUploadBtn = false;
                    });
            }
        },

        close() {
            this.dialog = false;
            setTimeout(() => {
                this.clientModel = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },
        clean() {
            this.clientModel = new ClientModel();
        },

        hideUploadModal() {
            this.uploadModal = false;
            this.file = null;
        },
    },
};
</script>
